import { selectSalesIntelligenceState } from "app/pages/sales-intelligence/store/selectors";
import { createStatePropertySelector } from "app/pages/sales-intelligence/store/utils";

import type { TeamsState } from "./types";

const selectTeamsState = createStatePropertySelector<TeamsState>(selectSalesIntelligenceState("teams"));

export const selectTerritoryEnabled = selectTeamsState("isEnabled");

export const selectSelectedTeamId = selectTeamsState("selectedTeamId");
